// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "c7924f0-dirty",
    "hash": "c7924f0",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c7924f0-dirty",
    "semverString": null,
    "version": "2.1.0"
};
/* tslint:enable */
